import styled from 'styled-components';
import AlertIcon from 'assets/images/alert.svg';
import { Image } from 'antd';
import { useTranslation } from '@packages/utils';
import {
  stepTwoKey,
  eventInfoSectionKey,
} from 'components/Shared/RegisterAction/RegistrationModal/RegistrationModal.data';

const WarningWrapper = styled.div`
  border: 1px solid #ff8b4d;
  border-radius: 4px;
  background-color: #fff7f0;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;

  .ant-image,
  .ant-image-mask,
  .ant-image-img {
    pointer-events: none !important;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
  color: #656565;
`;

export const AdultWarning = () => {
  const { t: tStepTwo } = useTranslation({
    keyPrefix: stepTwoKey,
    lng: 'translate',
  });

  return (
    <WarningWrapper>
      <Image alt="Registration Modal Art" src={AlertIcon} />
      <div>
        {tStepTwo('ADULT_WARNING')} <br />
        <strong>{tStepTwo('REGISTER_ADULT')}</strong>
      </div>
    </WarningWrapper>
  );
};

export const CapacityWarning = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation({
    keyPrefix: eventInfoSectionKey,
    lng: 'translate',
  });

  return (
    <WarningWrapper>
      <Image alt="Registration Modal Art" src={AlertIcon} width={60} />
      <div>{t('FULL_CAPACITY_WARNING')}</div>
      <CloseButton onClick={onClose}>&times;</CloseButton>
    </WarningWrapper>
  );
};

export const AgeGroupWarning = ({
  ageGroup,
  onClose,
}: {
  ageGroup: string;
  onClose: () => void;
}) => {
  return (
    <WarningWrapper>
      <Image alt="Registration Modal Art" src={AlertIcon} width={60} />
      <div>
        Class of an age group ({ageGroup}) is full. You can still proceed and we
        will add you to the waitlist.
      </div>
      <CloseButton onClick={onClose}>&times;</CloseButton>
    </WarningWrapper>
  );
};
